import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/forms/")({
  beforeLoad: ({ context }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/forms",
      params: { organizationBusinessUnitId },
    });
  },
});
